import { createContext, useContext, useEffect, useState } from "react";

import API from "../utils/api";

import { useConfig } from "./config-context";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const siteConfig = useConfig();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await API("/users/me");
        setUser(response?.data || null);
      } catch (error) {
        console.error("Erreur lors de la vérification du token", error);
      } finally {
        setLoading(false);
      }
    };
    const verifyAccountBasePath =
      siteConfig.routes.verify_account.path.split("/:")[0];
    const resetPasswordBasePath =
      siteConfig.routes.reset_password.path.split("/:")[0];
    const prescriberAccessBasePath =
      siteConfig.routes.prescriber_otp.path.split("/:")[0];
    const reportAccessBasePath =
      siteConfig.routes.report_access.path.split("/:")[0];
    if (
      ![
        siteConfig.routes.login.path,
        siteConfig.routes.forgot_password.path,
        siteConfig.routes.validate_email.path,
        siteConfig.routes.politique_cookies.path,
      ].includes(window.location.pathname) &&
      !window.location.pathname.startsWith(prescriberAccessBasePath) &&
      !window.location.pathname.startsWith(reportAccessBasePath) &&
      !window.location.pathname.includes(resetPasswordBasePath) &&
      !window.location.pathname.includes(verifyAccountBasePath)
    ) {
      fetchUser();
    } else {
      setLoading(false);
    }
  }, [
    siteConfig.routes.forgot_password.path,
    siteConfig.routes.login.path,
    siteConfig.routes.politique_cookies.path,
    siteConfig.routes.reset_password.path,
    siteConfig.routes.validate_email.path,
    siteConfig.routes.verify_account.path,
    siteConfig.routes.prescriber_otp.path,
    siteConfig.routes.report_access.path,
  ]);

  const login = async (email, password) => {
    try {
      const { data } = await API.post("/login", { email, password });
      if (data.user) {
        setUser(data.user);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const logout = async () => {
    try {
      await API.post("/logout");
      setUser(null);
    } catch (error) {
      console.error(error);
    }
  };

  const refreshUser = async () => {
    try {
      const response = await API("/users/me");
      setUser(response?.data || null);
    } catch (error) {
      console.error("Erreur lors du rafraîchissement de l'utilisateur", error);
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, refreshUser, loading }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};
